import {FC} from 'react';

import TableBody from '@mui/material/TableBody';
import ShowContactPersonRow from './ShowContactPersonRow';

import {IContactPerson} from '../../../../shared/types/person.types';

interface IShowContactPersonsComponent {
  contactPersons: IContactPerson[];
}

const ContactPersonsOfCompanyBeingEdited: FC<IShowContactPersonsComponent> = ({contactPersons}) => {
  return (
    <TableBody>
      {contactPersons.map((row) => (
        <ShowContactPersonRow key={row.id} row={row} />
      ))}
    </TableBody>
  );
};

export default ContactPersonsOfCompanyBeingEdited;
